var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedcreateworkflow",
	init: init,
	triggers: triggers,
	listeners: listeners,

	_managee: null,
	_definitionId: null,
	_definitions: null,

	handle_reset: handle_reset,
	load_manager: load_manager,
	load_contacts: load_contacts
});

function init() {
	this._managee = null;
	this._definitionId = null;
	this._definitions = [];
	this.push({
		creating: false,
		definition: {},
		selecteddefinition: null,
	});
}

function listeners() {
	return {
		"manageddefinitionworkflow:updated": handle_definition_update
	};
}

function triggers() {
	return {
		"create": handle_creating,
		"close": handle_reset,
		"submit": handle_submit,
		"setdefinition": set_definition
	};
}

function handle_creating(data) {
	var managee = data.managee;
	var group = data.group;
	if (!managee) return;
	this._managee = managee;
	this._group = group;

	this.extend({
		creating: true
	});

	this.load_manager();
	this.load_contacts();

	this.dispatch("creating");

	this.emit("usermetrics:trigger:track", "open create pathway popup", {
		"who": managee
	});
}

function handle_submit(data) {

	var managee = this._managee;
	var group = this._group;
	var workflow = this._definitionId;
	var label = data.label;
	var actors = data.actors;
	var defaults = data.defaults;

	if (!managee || !actors || !workflow) {
		this.emit("usermetrics:trigger:track", "attempt to create invalid pathway", {
			who: managee
		});
		return this.emit("toast:trigger:show", {
			content: "workflow.error",
			style: "error"
		});
	}

	this.emit("usermetrics:trigger:track", "create new pathway", {
		who: managee,
		pathwayId: workflow
	});


	var actorsList = Object.keys(actors).reduce(function (result, actLabel) {
		var supplied = actors[actLabel];
		if(!supplied) return result;

		if(supplied.patientGroups || supplied.people){
			result = result
				.concat((supplied?.patientGroups || []).reduce(reduceActor(actLabel, "ManageGroup"), []))
				.concat((supplied?.people || []).reduce((reduceActor(actLabel)), []));
		} else {
			result = result.concat(supplied.reduce(reduceActor(actLabel), []));
		}
		return result;
	}, []);


	this.emit("save:trigger:start");
	this.api.manage.workflow
		.create(managee, label, workflow, actorsList, defaults, group)
		.then(finish_load.bind(this))
		.catch(handle_error.bind(this));
}

function reduceActor(actLabel, type){
	return (acc, actor) => {
		if(actor)
			return acc.concat({
				who: actor,
				actor: actLabel,
				...(type && {type})
			});
		return acc;
	};
}

function handle_error(e) {
	this.emit("save:trigger:finish");
	console.error("Workflow create error: ", e);
	this.emit("toast:trigger:show", {
		content: "workflow.error",
		style: "error",
		immediate: true
	});
}

function finish_load() {
	this.emit("save:trigger:finish");
	this.handle_reset();
	this.emit("toast:trigger:show", {
		content: "workflow.workflowsaved"
	});
}

function handle_reset() {
	if(!this.data.creating) return;
	this.push({
		creating: false,
		definition: {},
		selecteddefinition: null,
	});
	this.emit("managedmanagers:trigger:reset");
	this.dispatch("finished");
	this.emit("usermetrics:trigger:track", "close create pathway popup", {
		who: this._managee
	});
}

function set_definition(data) {
	this._definitionId = data.definitions;
	var selectedDefinition = this._definitions.filter(function (definition) {
		return definition._id === data.definitions;
	});

	// TODO: Emit error saying invalid definition
	if(!selectedDefinition.length) return;

	this.extend({
		definition: selectedDefinition[0],
		selecteddefinition: this._definitionId
	});
}

function load_manager() {
	var managee = this._managee;

	this.emit("managedmanagers:trigger:load", {
		who: managee
	});
}

function load_contacts(){
	var managee = this._managee;
	var group = this._group;

	this.emit("managedcontacts:trigger:load", {
		who: managee,
		group: group
	});
}

function handle_definition_update(data) {
	this._definitions = data;
}